import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Modal from 'react-bootstrap/Modal'
import Table from "react-bootstrap/Table";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from 'react-bootstrap/Dropdown'
import { useState } from "react";
import './index.css'
import { GetEvents, DeleteEvent, GetResults } from '../../ApiRequests'
import { GiBulletBill } from 'react-icons/gi'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Cookies from 'universal-cookie'
import cookieUtils from "../../Utilities/CookieUtils";


const Events = (props) => {
    const cookies = new Cookies()
    const cookie = cookies.get('jwt')
    const { scope, userId } = cookieUtils.getScopeFromJWT(cookie)

    const [events, setEvents] = useState([])
    const [event, setEvent] = useState({})
    const [showDeleteEvent, setShowDeleteEvent] = useState(false)
    const [showResults, setShowResults] = useState(false)
    const [results, setResults] = useState([])
    const [filteredResults, setFilteredResults] = useState([])
    const [eventId, setEventId] = useState('')
    const [genderFilter, setGenderFilter] = useState('Male')
    const [pointsFilter, setPointsFilter] = useState('Overall')

    const getEvents = async () => {
        const _events = await GetEvents()
        if (_events) {
            setEvents(_events.data)
        }
    }

    const getResults = async () => {
        const res = await GetResults();
        if (!res || !res.data) { return }

        const genderFilter = 'm';
        const sortedResults = res.data.sort((a, b) => b.total_points - a.total_points);
        setResults(sortedResults)

        const filtered = sortedResults.filter((result) => {
            const isGenderMatch = result.rider_gender === genderFilter;
            return isGenderMatch;
        });


        setFilteredResults([...filtered])
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${day}-${month}-${year}`;
    }

    const deleteEventConfirm = async () => {
        console.log(event)
        const res = await DeleteEvent(event._id)

        if (!res) {
            console.log("COULD NOT DELETE EVENT")
            return
        }
        setShowDeleteEvent(false)
        getEvents()
    }


    const handleFilter = (genderValue, pointsFilter) => {
        setGenderFilter(genderValue)
        setPointsFilter(pointsFilter)

        const genderFilter = genderValue === 'Male' ? 'm' : 'f';
        const filtered = results.filter((result) => {
            const isGenderMatch = genderValue === 'All' || result.rider_gender === genderFilter;
            return isGenderMatch;
        });

        let filteredAndSortedRiders = [...filtered]
        if (pointsFilter == 'Qualifying') {
            filteredAndSortedRiders.sort((a, b) => b?.qualifying_points - a?.qualifying_points);

        } else if (pointsFilter == 'Semis') {
            filteredAndSortedRiders.sort((a, b) => b?.semis_points - a?.semis_points);

        } else if (pointsFilter == 'Finals') {
            filteredAndSortedRiders.sort((a, b) => b?.finals_points - a?.finals_points);

        } else if (pointsFilter == 'Overall') {
            filteredAndSortedRiders.sort((a, b) => b?.total_points - a?.total_points);

        }

        setFilteredResults(filteredAndSortedRiders);
    }


    useEffect(() => {
        getEvents()
        getResults()
    }, []);

    const renderResults = (result, index, type) => {
        return (
            <>
                {
                    result.eventId == event._id &&
                    <tr key={index}>
                        <td style={{fontSize:'14px'}}>{index + 1}</td>
                        <td style={{fontSize:'14px'}}>{result.rider_first_name} <b>{result.rider_last_name}</b></td>
                        {type == 'Overall' && <td className="d-flex justify-content-between" style={{fontSize:'14px'}}>{result.total_points}</td>}
                        {type == 'Qualifying' && <td className="d-flex justify-content-between" style={{fontSize:'14px'}}>{result.qualifying_points}</td>}
                        {type == 'Semis' && <td className="d-flex justify-content-between" style={{fontSize:'14px'}}>{result.semis_points}</td>}
                        {type == 'Finals' && <td className="d-flex justify-content-between" style={{fontSize:'14px'}}>{result.finals_points}</td>}
                    </tr>
                }
            </>
        )
    }


    const renderEvents = (_event, index) => {
        return (
            <div className="" key={index}>
                <Card className="mx-3 mb-4 border-0 shadow">
                    <Card.Header as="h5">{_event.discipline} World Cup</Card.Header>
                    <Card.Body>

                        <div className="row">
                            <div className="col-md-3 fw-light" style={{ color: 'grey' }}>Location</div>
                            <div className="col-md-3 fw-light" style={{ color: 'grey' }}>Event</div>
                            <div className="col-md-3 fw-light" style={{ color: 'grey' }}>Date</div>
                            {/* {scope == 'admin' &&
                                <div className="col-md d-flex flex-row justify-content-end">
                                    <Button variant="outline-secondary" onClick={() => { setEvent(_event); setShowDeleteEvent(true) }}>Edit</Button>
                                </div>} */}
                        </div>
                        <hr className="mt-1"></hr>
                        <div className="row">
                            <div className="col-md-3">{_event.location}</div>
                            <div className="col-md-3">{_event.discipline}</div>
                            <div className="col-md-3">{formatDate(_event.date)}</div>
                            <div className="col-md d-flex justify-content-end">
                                <Button variant='outline-primary' onClick={() => { setShowResults(true); setEvent(_event) }}>View Results</Button>
                            </div>
                            {/* {scope == 'admin' &&
                                <div className="col-md d-flex flex-row justify-content-end">
                                    <Button variant="outline-danger" onClick={() => { setEvent(_event); setShowDeleteEvent(true) }}>Delete</Button>
                                </div>} */}
                        </div>

                    </Card.Body>
                </Card>
            </div>
        )
    }

    return (
        <div className="container container-background py-3" style={{ minHeight: '100vh' }}>
            {events.length != 0 &&
                <div className="pt-4">
                    {Array.isArray(events) && events.map(renderEvents)}
                </div>
            }

            <Modal show={showDeleteEvent} onHide={() => setShowDeleteEvent(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Event: {event?.location}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete {event?.location}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteEvent(false)}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => deleteEventConfirm()}>
                        Delete Event
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size='lg' show={showResults} onHide={() => setShowResults(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Results for Event: {event?.location}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row my-2 mb-3">
                        <div className="col-sm-1 me-4 d-flex align-items-center">Category:</div>
                        <div className="col-sm d-flex justify-content-start">
                            <DropdownButton size='md' className="" onChange={(e) => handleFilter(e.target.value)} id="dropdown-basic-button" variant='outline-secondary' title={genderFilter} >
                                <Dropdown.Item value='Male' onClick={(e) => handleFilter(e.target.text, pointsFilter)}>Male</Dropdown.Item>
                                <Dropdown.Item value='Female' onClick={(e) => handleFilter(e.target.text, pointsFilter)}>Female</Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </div>


                    <Tabs
                        defaultActiveKey="Overall"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        onSelect={(e) => handleFilter(genderFilter, e)}
                    >
                        <Tab eventKey="Overall" title="Overall">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Overall'))}
                                </tbody>
                            </Table>

                        </Tab>
                        <Tab eventKey="Qualifying" title="Qualifying" onClick={() => handleFilter(genderFilter, 'Qualifying')}>
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Qualifying'))}
                                </tbody>
                            </Table>
                        </Tab>
                        <Tab eventKey="Semis" title="Semi Finals">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Semis'))}
                                </tbody>
                            </Table>
                        </Tab>
                        <Tab eventKey="Finals" title="Finals">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Finals'))}
                                </tbody>
                            </Table>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowResults(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Events;